module.exports = __webpack_public_path__ + "static/media/calendar.a3416f23.svg";